var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:[_vm.classes, _vm.availabilityClasses],attrs:{"data-preload":[_vm.$options.name]}},[_c('li',{staticClass:"text"},[_c('strong',[_vm._v(" "+_vm._s(_vm.availabilityLabel)+" ")]),_vm._v(" "),(!!_vm.availabilityText && !_vm.isBusinessCustomer)?_c('span',[_vm._v(_vm._s(_vm.availabilityText))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }